'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveStore = exports.loadStore = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadStore = exports.loadStore = function loadStore() {
  try {
    var serializedState = global.localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

var saveStore = exports.saveStore = function saveStore(state) {
  try {
    var serializedState = (0, _stringify2.default)(state);
    global.localStorage.setItem('state', serializedState);
  } catch (err) {
    // Ignore write errors.
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/localStorage.js
// module id = 1698
// module chunks = 0